const getToken = () => JSON.parse(localStorage.getItem(`__token`));
const setUser = (user) => sessionStorage.setItem('__stip_port_user', JSON.stringify(user));
const getUser = () => JSON.parse(sessionStorage.getItem(`__stip_port_user`));
const setToken = (token) => localStorage.setItem(`__token`, JSON.stringify(token));
const deleteToken = () => localStorage.removeItem(`__token`);
const deleteUser = () => sessionStorage.removeItem(`__stip_port_user`);

const getHeaders = () => {
    const headers = {};
    const token = getToken();
    if (!!token) {
        headers.Authorization = `Bearer ${token}`;
    }
    return headers;
};

const localStorageAuthEndpoints = {
    getToken,
    setToken,
    deleteToken,
    deleteUser,
    setUser,
    getUser,
    getHeaders,
};
export default localStorageAuthEndpoints;
